

























import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseDialog, Button, Input, SvgIcon } from "@brankas/web-ui";

@Component({
  components: {
    BaseDialog,
    Button,
    Input,
    SvgIcon,
  },
})
export default class DownloadTransactionsDialog extends Vue {
  @Prop({ type: Boolean, default: "" }) clientName!: string;

  onConfirm() {
    this.$emit("confirm");
  }
}
